import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-evernorth-logo',
  templateUrl: './evernorth-logo.component.html',
  styleUrls: ['./evernorth-logo.component.scss'],
})
export class EvernorthLogoComponent {
  @Input() color:
    | 'champagne'
    | 'darkmint'
    | 'hypermint'
    | 'tempermint'
    | 'white' = 'hypermint';

  get logoPath(): string {
    return `assets/images/evn_logo_hs_r_rgb_${this.color}.svg`;
  }
}
